module.exports = __webpack_public_path__ + "media/post-rental-listing-light.dadecb04.svg";